import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

function RulesSection() {
  const { t, i18n } = useTranslation();
  const base = process.env.PUBLIC_URL || "";

  const tender = useMemo(() => {
    const isZh = i18n.language === "zh";
    const path = isZh
      ? "/documents/第十八届世界精武武术锦标赛暨文化大会.pdf"
      : "/documents/18th_World_Chin_Woo_Martial_Arts_Championship_&_Culture_Assembly.pdf";
    const fileName = isZh
      ? "第十八届世界精武武术锦标赛暨文化大会.pdf"
      : "18th_World_Chin_Woo_Martial_Arts_Championship_&_Culture_Assembly.pdf";
    return { href: `${base}${path}`, fileName };
  }, [i18n.language, base]);

  return (
    <section
      className="relative z-10 bg-white pb-14 pt-12 transition-colors dark:bg-slate-800 md:pb-16 md:pt-14"
      id="rules-section"
      aria-labelledby="taolu-rules-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <header className="mb-10 text-center md:mb-12">
          <h2
            id="taolu-rules-heading"
            className="relative mb-5 inline-block text-4xl font-semibold tracking-tight text-primary dark:text-primary-light md:text-5xl"
          >
            {t("taolu_rules.title")}
            <span
              className="absolute -bottom-2.5 left-1/2 h-0.5 w-16 -translate-x-1/2 rounded-full bg-primary dark:bg-primary-light"
              aria-hidden
            />
          </h2>
        </header>

        <div className="mx-auto max-w-3xl">
          <p className="mb-8 text-pretty text-center text-lg leading-relaxed text-slate-600 dark:text-slate-400">
            {t("taolu_rules.text")}
          </p>

          <a
            href={tender.href}
            download={tender.fileName}
            className="group flex items-center gap-4 rounded-2xl border border-slate-200 border-l-4 border-l-primary bg-white p-4 shadow-sm transition-all dark:border-slate-700 dark:border-l-primary-light dark:bg-slate-800 motion-safe:hover:shadow-md sm:p-5 md:gap-5 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2 dark:focus-visible:ring-primary-light/40 dark:focus-visible:ring-offset-slate-900"
            aria-label={t("taolu_rules.download_tender_aria")}
          >
            <div
              className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-primary/10 transition-transform duration-300 dark:bg-primary-light/15 sm:h-14 sm:w-14 motion-safe:group-hover:scale-105"
              aria-hidden
            >
              <i className="fas fa-file-pdf text-xl text-primary dark:text-primary-light sm:text-2xl" />
            </div>
            <div className="min-w-0 flex-1 text-left">
              <span className="block text-base font-semibold text-slate-900 dark:text-slate-100 sm:text-lg">
                {t("taolu_rules.download_tender")}
              </span>
              <span className="mt-0.5 block text-sm text-slate-500 dark:text-slate-400">
                {t("taolu_rules.download_file_hint")}
              </span>
            </div>
            <span
              className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-slate-100 text-slate-600 transition-colors group-hover:bg-primary/10 group-hover:text-primary dark:bg-slate-700 dark:text-slate-300 dark:group-hover:bg-primary-light/15 dark:group-hover:text-primary-light"
              aria-hidden
            >
              <i className="fas fa-download text-sm" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default RulesSection;
